import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
`

export const ListTitle = styled.div`
  display: flex;
  border-radius: 8px 8px 0px 0px;
  flex: 1;
  width: 100%;
  padding: 10px 15px;
  box-shadow: 0 0 7px 10px -5px rgba(12, 35, 64, 0.4);
  background-color: ${colors.prixBlue};
  justify-content: space-between;
  flex-wrap: wrap;

  .label {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    min-width: 0;
    font-size: 18px;
  }

  .actions {
    display: flex;
    font-size: 19px;

    align-items: center;
    justify-content: center;
  }

  p {
    color: #fff;
    font-size: 19px;
    font-weight: 700;
    line-height: 0;

    @media (max-width: 768px) {
      font-size: 1.3rem;
    }
  }
`

interface HeaderProps {
  title: string
  extraButtons?: JSX.Element
  subtitle?: string
}

export default function Header({ title, subtitle, extraButtons }: HeaderProps) {
  return (
    <Wrapper>
      <ListTitle>
        <div className='label'>
          <p>{title}</p>
        </div>

        <div className='actions'>{extraButtons}</div>
      </ListTitle>
    </Wrapper>
  )
}
